module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2021.e1a7fabd.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2021.png
// module id = 1152
// module chunks = 0